var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEasyAndSecure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.281,
    height: 60.049,
    viewBox: "0 0 67.281 60.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12986",
    d: "M63.889 29.857a13.593 13.593 0 0 0-1.256-1.444L43.986 9.766a5.261 5.261 0 0 0-7.446 0L7.66 38.646a5.261 5.261 0 0 0 0 7.446L19.94 58.36",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    transform: "translate(-5.116 -7.222)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12987",
    d: "M62.665 24.375h-41.01a5.236 5.236 0 0 0-5.236 5.236v25.942a5.236 5.236 0 0 0 5.236 5.236h41.01a5.236 5.236 0 0 0 5.235-5.236V29.611a5.236 5.236 0 0 0-5.235-5.236z",
    transform: "translate(-1.62 -1.74)",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12988",
    d: "M16.419 31.875H67.9",
    transform: "translate(-1.62 .805)",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12989",
    d: "M16.419 35.625H67.9",
    transform: "translate(-1.62 2.078)",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12990",
    d: "M22.044 41.25h10.045",
    transform: "translate(.289 3.987)",
    style: {
      stroke: "#d24350",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12991",
    d: "M22.044 45h6.278",
    transform: "translate(.289 5.259)",
    style: {
      stroke: "#d24350",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12992",
    d: "M33.294 41.25h6.278",
    transform: "translate(4.107 3.987)",
    style: {
      stroke: "#d24350",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyAndSecure);
export default __webpack_public_path__ + "static/media/easy-and-secure.356c9bdb9d00a22c9fb735b78973acc6.svg";
export { ForwardRef as ReactComponent };